import React from 'react';
import _ from 'lodash';
import connectFirebase from "../lib/firebase/connectFirebase";


export class SampleChatClient extends React.PureComponent {

  state = {
    body: ''
  };

  render() {
    const {userId, name, messages, sendMessage} = this.props;
    const {body} = this.state;
    return <div>
      {_.map(_.orderBy(messages, 'created'), m => <div key={m.id}>{m.body}</div>)}
      <form onSubmit={e => {
        e.preventDefault();
        if (!body) return;
        sendMessage(body);
        this.setState({body: ''});
      }}>
        <input type="text" value={body} onChange={e => this.setState({
          body: e.target.value
        })}/>
        <button>send</button>
      </form>
    </div>;
  }
}

const getListeners = ({firebase, ownProps}) => {
  const userId = '' + (ownProps.userId || firebase.auth().currentUser.uid);

  return {
    chatrooms: {
      where: ['userId', '==', userId]
    },
    messages: {
      where: ['userId', '==', userId]
    }
  };
};

const dataToProps = ({data, firebase, ownProps}) => {
  const userId = '' + (ownProps.userId || firebase.auth().currentUser.uid);
  const {name} = ownProps;
  const chatroom = data.chatrooms[userId];

  return {
    messages: _.pickBy(data.messages, {userId}),
    chatroom,
    createChatroom: userId => {
      const docRef = firebase.firestore().doc(`chatrooms/${userId}`);
      return docRef.get().then(snap => {
        if (snap.exists) return snap.data({
          serverTimestamps: 'estimate'
        });
        else return docRef.set({
          userId,
          created: firebase.firestore.FieldValue.serverTimestamp()
        }).catch(e => console.log(e));
      });

    },
    setName: name => firebase.firestore().doc(`chatrooms/${userId}`).update({name}),
    unreadMessageCount: chatroom ? _.filter(data.messages, m => m.created > chatroom.lastReadTime).length : _.size(data.messages),
    sendMessage: (body, {imageUrl = null, platform = null,
      autoReply = null, // {answer, actionKey, buttonString, ...}
      channel = null, language = window.navigator.language.substr(0, 2)} = {}) => firebase.firestore().collection('messages').add({
      userId,
      body,
      imageUrl,
      platform,
      language,
      channel,
      type: 'user', // 'user' or 'admin'
      autoReply,
      created: firebase.firestore.FieldValue.serverTimestamp()
    }),
    uploadImage: async imageFile => {
      const storageRef = firebase.storage().ref();
      const imageRef = storageRef.child(`images/${Date.now()}_${imageFile.name}`);
      const res = await imageRef.put(imageFile);
      return res.downloadURL;
    },
    markAsRead: () => firebase.firestore().doc(`chatrooms/${userId}`).update({
      lastReadTime: firebase.firestore.FieldValue.serverTimestamp()
    }),
    userId, name
  };
};

export const connectChatClient = connectFirebase(getListeners, dataToProps);

export const ConnectedChatClient = connectChatClient(SampleChatClient);

export const initializeFirebase = require('../lib/firebase/initializeFirebase').default;
export const FirebaseProvider = require('../lib/firebase/FirebaseProvider').FirebaseProvider;
export const FirestorePersistGate = require('../lib/firebase/FirestorePersistGate').FirestorePersistGate;
export const AnonymousSignInGate = require('../lib/firebase/AnonymousSignInGate').AnonymousSignInGate;